import React, { useMemo, useState } from 'react';
import { Button } from '@sandtech-hub-monorepo/ui-kit';

import { ReactComponent as InfoIcon } from '../../assets/Icons/info-icon.svg';
import { UpdateCourseStatusDialog } from './UpdateCourseStatusDialog';
import {
  ClassEnrollmentStatus,
  GetViewerLearningDetailsDocument,
} from '@sandtech-hub-monorepo/ehub-client';
import { useQuery } from '@apollo/client';

export const ProgramStatusManagementCard: React.FC = () => {
  const [courseUpdateOpen, setCourseUpdateOpen] = useState(false);
  const { data } = useQuery(GetViewerLearningDetailsDocument, {
    fetchPolicy: 'cache-first',
  });
  const programEnrollments = useMemo(
    () =>
      (
        data?.viewer.programEnrollments?.filter(
          (p) => p.status === 'ONGOING'
        ) || []
      ).map((pe) => ({
        ...pe,
        canWithdraw: !!pe.plannedCourses.find(
          ({ enrollment }) =>
            enrollment?.currentClass?.status !== ClassEnrollmentStatus.Failed
        ),
        canDefer:
          pe.program.allowCourseDeferral &&
          !!pe.plannedCourses.find(
            ({ enrollment }) =>
              enrollment?.currentClass?.status === ClassEnrollmentStatus.Ongoing
          ),
      })),
    [data?.viewer.programEnrollments]
  );

  const canDefer = !!programEnrollments.find(({ canDefer }) => canDefer);
  const canWithdraw = !!programEnrollments.find(
    ({ canWithdraw }) => canWithdraw
  );

  return (
    <>
      <div className="sm:min-w-[420px] flex-1 bg-primary/10 p-8 border rounded-sm border-primary/20 flex gap-6 items-start">
        <div className="p-6 bg-primary/20 rounded-full text-secondary sm:block hidden">
          <InfoIcon />
        </div>
        <div className="flex flex-col gap-2 items-start mb-1">
          <h3 className="text-secondary text-3xl font-semibold">
            {canDefer ? 'Defer or withdraw' : 'Withdraw'}
          </h3>
          <div>
            {canDefer
              ? `Deferring lets you select courses to resume later, while
            withdrawing ends your enrollment.`
              : 'Withdrawing from your program will end it permanently. You will need to reapply.'}
          </div>
          <Button
            className="mt-1"
            onClick={() => setCourseUpdateOpen(true)}
            disabled={!programEnrollments.length || (!canDefer && !canWithdraw)}
          >
            Continue
          </Button>
        </div>
      </div>
      <UpdateCourseStatusDialog
        open={courseUpdateOpen}
        onOpenChange={setCourseUpdateOpen}
        programEnrollments={programEnrollments}
      />
    </>
  );
};
